'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InfoPartition = require('../InfoPartition/InfoPartition');

var _InfoPartition2 = _interopRequireDefault(_InfoPartition);

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Security = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Security, _Component);

  function Security() {
    (0, _classCallCheck3.default)(this, Security);
    return (0, _possibleConstructorReturn3.default)(this, (Security.__proto__ || (0, _getPrototypeOf2.default)(Security)).apply(this, arguments));
  }

  (0, _createClass3.default)(Security, [{
    key: 'render',


    /* eslint-disable max-len */
    value: function render() {
      var t = this.props.t;

      var text = {
        title: t('Security'),
        preKey: 'security_',
        body: t('Cright takes very seriously its obligations in respect of your Personal Data under the Data Protection Acts to prevent unauthorised access to, or alteration or destruction of Personal Data in our possession. Nobody can access your files unless you choose to share them yourself. However, unfortunately, no data transmission over the Internet can be guaranteed to be 100% secure. As a result, we cannot 100% ensure the security of any information you transmit to us or from our online products or Services, and you do so at your own risk. We will take reasonable steps to protect information shared with us from unauthorised access or disclosure.'),
        articles: [{
          key: 'storage_',
          header: t('Secure Storage'),
          bodies: [t('Cright shares the same secure methods used by the most secure of organizations, such as banks and the military, to protect your data.'), _react2.default.createElement(_reactI18next.Interpolate, {
            i18nKey: 'On some occasions, Cright may use Amazon S3 for data storage. Amazon stores its data over several large-scale data centres. According to Amazon, they use military grade perimeter control berms, video surveillance, and professional security staff to keep their data centres physically secure. More information on Amazon\\\'s security can be found at {{amazonLink}}. Cright retains data collected on your behalf after termination of any agreement with you in its non-active, back-up archive files on a secure server or other commercially acceptable secure media for up to 12 months to enable it to meet its security obligations.',
            amazonLink: _react2.default.createElement(
              'a',
              { target: '_blank', href: 'http://aws.amazon.com/articles/1697?_encoding=UTF8&jiveRedirect=1', rel: 'noopener noreferrer' },
              t('Amazon Web Services\' website')
            )
          })]
        }, {
          key: 'transfers_',
          header: t('Secure Transfers'),
          bodies: [t('All transmission of file data and metadata occurs over an encrypted channel (SSL). Any data transferred from Cright over the internet is securely encrypted and safe from interception and/or eavesdroppers.'), t('Cright also employ significant protection against network security issues such as Man in the Middle (MITM) attacks, and packet sniffing.')]
        }, {
          key: 'backedup-data_',
          header: t('Your Data is Backed Up'),
          bodies: [t('Cright keeps multiple redundant backups of all data over multiple locations to prevent the remote possibility of issues occurring in data centres.')]
        }, {
          key: 'privacy-policy_',
          header: t('Cright\'s Privacy Policy'),
          bodies: [t('The files stored on your Cright account are accessible only to you via your login. Cright employees are only permitted access to file metadata (file names and locations). No employee is allowed to view the files in your Cright account without your consent.'), t('The information provided in your account profile is used internally for support, maintenance, and improvement of the Cright service. We understand and guard your privacy to the best of our ability as described in this policy. We do our utmost to protect your information from unauthorized access.')]
        }, {
          key: 'found-exploit_',
          header: t('I think I\'ve found a security exploit. Where do I report security concerns?'),
          bodies: [t('Our top priority is making Cright safe for all of its users. While we\'re very confident in our security technology, we prefer to investigate any and all reported security concerns with any of Cright\'s services or software.'), _react2.default.createElement(_reactI18next.Interpolate, {
            i18nKey: 'For a direct line to our security experts, report security problems to {{email}}',
            email: _react2.default.createElement(
              'a',
              { target: '_blank', href: 'mailto:security@cright.com', rel: 'noopener noreferrer' },
              'security@cright.com'
            )
          })]
        }]
      };

      return _react2.default.createElement(_InfoPartition2.default, { text: text });
    }
    /* eslint-enable max-len */

  }]);
  return Security;
}(_react.Component), _class2.propTypes = {
  t: _propTypes2.default.func.isRequired
}, _temp)) || _class);
exports.default = Security;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Info/Security/Security.js
// module id = 2025
// module chunks = 1